import useSearcherClassesInput from "../../../../../../hooks/common/searchers/inputs/useClassesInput.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useSearcherFlightHotelDefaultValues from "../../hooks/useSearcherFlightHotelDefaultValues.js";
const useClassesInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { classes , config  } = props ?? {};
    const { literals  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { isLoading  } = state ?? {};
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    return useSearcherClassesInput({
        label: literals?.classesLabel,
        options: classes,
        defaultValue: defaultValues.classes,
        disabled: isLoading,
        shouldUnregister: true
    });
};
export default useClassesInput;

//# sourceMappingURL=useClassesInput.js.map